import React from 'react';

import { Note } from '../../../components/note/note';

import styles from './subscription-details.module.scss';
export interface MarketplaceSubscriptionDetails {
  email: string;
  planName: string;
  subscriptionName: string;
  tenantId: string;
}

type SubscriptionDetailsProps = {
  subscription: MarketplaceSubscriptionDetails;
};

export const SubscriptionDetailsPage: React.FC<SubscriptionDetailsProps> = ({ subscription }) => (
  <div className={styles['container']}>
    <Note>
      Please verify the following information is correct before submitting your subscription.
    </Note>

    <div className={styles['items']}>
      <div>
        <h3>Email</h3>
        <p>{subscription.email}</p>
      </div>

      <div>
        <h3>Plan</h3>
        <p>{subscription.planName}</p>
      </div>

      <div>
        <h3>Subscription name</h3>
        <p>{subscription.subscriptionName}</p>
      </div>

      <div>
        <h3>Tenant ID</h3>
        <p>{subscription.tenantId}</p>
      </div>
    </div>
  </div>
);
